/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
  Editor,
  EditorState,
  ContentState,
  SelectionState,
  Modifier,
} from 'draft-js';
import 'draft-js/dist/Draft.css';
import Clipboard from 'clipboard';
import Esprima from 'esprima';
import { Map, List } from 'immutable';
import jsBeautify from 'js-beautify';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import RichButton from 'loracoms/RichButton';
import Flash from 'loracoms/Flash';
import { getParserCode } from 'loraactions/parser';
import Line from '../Line';
import styles from './styles.scss';

const kIndent = 2;
const kIndentSpaces = '  ';
const kCodeBlock =
`var fport=119;
var bin = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
var data = '1122334455667788';
var appeui = '121212';
var deveui ='3434';
var hex = [1,1,1,1,1,1,1,11,1];
`;

const blockRenderMap = Map({
  unstyled: {
    element: 'pre',
  },
});

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  parserId: React.PropTypes.string.isRequired,
  parser: React.PropTypes.object.isRequired,
  getParserCode: React.PropTypes.func.isRequired,
};

class HighlightDecorator {

  getDecorations(block) {
    const text = block.getText();
    const decorations = Array(text.length).fill(null);
    const blockKey = block.getKey();
    try {
      const tokens = Esprima.tokenize(text, { range: true, comment: true });
      tokens.forEach((token) => {
        const [start, end] = token.range;
        _.range(start, end).forEach((idx) => {
          decorations[idx] = `${blockKey}.${start}.${token.type.toLowerCase()}`;
        });
      });
    } catch (e) {
      // do nothing
    }
    return List(decorations);
  }

  getComponentForKey(key) {
    const type = key.split('.')[2];
    return props => <span className={styles[type]}>{props.children}</span>;
  }

  getPropsForKey(key) {
    return {};
  }
}

const findReturns = (stmt) => {
  if (_.isNil(stmt)) {
    return [];
  }
  if (stmt.type === 'ReturnStatement') {
    return [stmt];
  }
  if (stmt.type === 'IfStatement') {
    return [
      ...findReturns(stmt.consequent),
      ...findReturns(stmt.alternate),
    ];
  }
  if (stmt.type === 'BlockStatement') {
    return _.flatMap(stmt.body, findReturns);
  }
  return [];
};

const findDataPointsForName = (name, stmt) => {
  if (_.isNil(stmt)) {
    return [];
  }

  if (stmt.type === 'VariableDeclaration') {
    const decls = stmt.declarations.filter(decl => decl.id.name === name);
    if (decls.length > 0) {
      const init = decls[0].init;
      if (init && init.type === 'ObjectExpression') {
        return init.properties.map(p => p.key.name);
      }
    }
    return [];
  } else if (stmt.type === 'ExpressionStatement') {
    const expr = stmt.expression;
    if (expr.type === 'AssignmentExpression') {
      if (expr.left.type === 'Identifier' &&
          expr.left.name === name &&
          expr.right.type === 'ObjectExpression') {
        return expr.right.properties.map(p => p.key.name);
      }
    }
    return [];
  } else if (stmt.type === 'IfStatement') {
    return _.union(
      findDataPointsForName(name, stmt.consequent),
      findDataPointsForName(name, stmt.alternate),
    );
  } else if (stmt.type === 'BlockStatement') {
    return _.reduce(
      stmt.body.map(s => findDataPointsForName(name, s)),
      (accDps, dps) => _.union(accDps, dps),
      [],
    );
  }
  return [];
};

const findDataPoints = (returnStmt, stmts) => {
  if (_.isNil(returnStmt.argument)) {
    return [];
  }
  if (returnStmt.argument.type === 'Literal') {
    return [];
  }
  if (returnStmt.argument.type === 'ObjectExpression') {
    return returnStmt.argument.properties.map(p => p.key.name);
  }
  if (returnStmt.argument.type === 'Identifier') {
    const name = returnStmt.argument.name;
    const dpsArr = stmts.map(stmt => findDataPointsForName(name, stmt));
    return _.reduce(dpsArr, (accDps, dps) => _.union(accDps, dps), []);
  }
  return [];
};

const blockRendererFn = (contentBlock) => {
  const type = contentBlock.getType();
  switch (type) {
    default:
      return { component: Line, editable: true };
  }
};

class ScriptEditor extends React.Component {

  constructor(props) {
    super(props);
    const {
      data: {
        parser: { script = '' } = {},
      } = {},
    } = props.parser;
    this.state = {
      editorState:
        EditorState.createWithContent(
          ContentState.createFromText(script, /[\r\n]/),
          new HighlightDecorator()),
      errors: ErrorSet.createEmpty(),
    };
    this.onChange = this.onChange.bind(this);
    this.onTab = this.onTab.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.indentBlocks = this.indentBlocks.bind(this);
    this.unindentBlocks = this.unindentBlocks.bind(this);
    this.indentFocus = this.indentFocus.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.parsers.scripteditor');
    const copy = new Clipboard('#copy');
    const that = this;
    copy.on('success', () => {
      that.setState({ copied: true });
    });
  }

  componentWillMount() {
    const {
      data: {
        parser: { script = '' } = {},
      } = {},
    } = this.props.parser;
    this.props.getParserCode(script);
  }

  componentWillReceiveProps(nextProps) {
    const { parser } = nextProps;
    if (parser !== this.props.parser) {
      const {
        data: {
          parser: { script = '' } = {},
        } = {},
      } = parser;
      this.setState({
        editorState:
          EditorState.createWithContent(
            ContentState.createFromText(script),
            new HighlightDecorator()),
      });
      this.props.getParserCode(script);
    }
  }

  onChange(editorState) {
    this.setState({ editorState });
    const lastChangeType = editorState.getLastChangeType();
    if (lastChangeType === 'split-block') {
      this.indentFocus(editorState);
    }
    this.props.getParserCode(editorState);
  }

  onTab(e) {
    e.preventDefault();
    const { editorState } = this.state;
    const selectionState = editorState.getSelection();
    const startKey = selectionState.getStartKey();
    const endKey = selectionState.getEndKey();
    const contentState = editorState.getCurrentContent();
    const blockMap = contentState
      .getBlockMap()
      .skipUntil((_, k) => k === startKey)
      .takeUntil((_, k) => k === contentState.getKeyAfter(endKey));
    if (e.shiftKey) {
      this.unindentBlocks(editorState, contentState, selectionState, blockMap);
    } else {
      this.indentBlocks(editorState, contentState, selectionState, blockMap);
    }
  }

  indentBlocks(
    editorState,
    contentState,
    selectionState,
    blockMap,
  ) {
    const indentContent = blockMap
      .reduce((content, block) => {
        const selection = SelectionState.createEmpty(block.getKey());
        return Modifier.insertText(
          content,
          selection,
          kIndentSpaces);
      }, contentState);
    const shiftSelection = selectionState.merge({
      anchorOffset: selectionState.getAnchorOffset() + kIndent,
      focusOffset: selectionState.getFocusOffset() + kIndent,
    });
    this.onChange(
      EditorState.forceSelection(
        EditorState.push(
          editorState,
          indentContent,
          'insert-characters',
        ),
        shiftSelection));
  }

  unindentBlocks(
    editorState,
    contentState,
    selectionState,
    blockMap,
  ) {
    const indentContent = blockMap
      .reduce((content, block) => {
        const selection = SelectionState.createEmpty(block.getKey()).merge({
          anchorOffset: 0,
          focusOffset: kIndent,
        });
        return Modifier.replaceText(
          content,
          selection,
          _.trimStart(block.getText().substr(0, kIndent)));
      }, contentState);
    const anchorOffset = selectionState.getAnchorOffset();
    const focusOffset = selectionState.getFocusOffset();
    const shiftSelection = selectionState.merge({
      anchorOffset: anchorOffset < kIndent ? 0 : anchorOffset - kIndent,
      focusOffset: focusOffset < kIndent ? 0 : focusOffset - kIndent,
    });
    this.onChange(
      EditorState.forceSelection(
        EditorState.push(
          editorState,
          indentContent,
          'delete-character',
        ),
        shiftSelection));
  }

  indentFocus(editorState) {
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    const focusKey = selectionState.getFocusKey();
    const beforeKey = contentState.getKeyBefore(focusKey);
    if (beforeKey) {
      const beforeBlock = contentState.getBlockForKey(beforeKey);
      let indentLevel = 0;
      if (_.endsWith(_.trimEnd(beforeBlock.getText()), '{')) {
        indentLevel += 1;
      }
      const match = beforeBlock.getText().match(/^\s+/);
      if (match) {
        indentLevel += Math.ceil(match[0].length / kIndent);
      }
      if (indentLevel > 0) {
        const indentSpaces = _.range(indentLevel).map(() => kIndentSpaces).join('');
        const indentSelection = selectionState.merge({
          anchorOffset: selectionState.getAnchorOffset() + indentSpaces.length,
          focusOffset: selectionState.getFocusOffset() + indentSpaces.length,
        });
        this.onChange(EditorState.forceSelection(
          EditorState.push(
            editorState,
            Modifier.insertText(
              contentState,
              selectionState,
              indentSpaces),
            'insert-characters'),
          indentSelection));
      }
    }
  }

  handleBeauty() {
    const { editorState } = this.state;
    let code = editorState.getCurrentContent().getPlainText();
    code = jsBeautify.js_beautify(code);
    this.setState({
      editorState: EditorState.createWithContent(
        ContentState.createFromText(code, /[\r\n]/),
        new HighlightDecorator()),
    });
  }

  handleSubmit() {
    const { parserId } = this.props;
    const { editorState } = this.state;
    let { errors } = this.state;

    errors = errors.remove('submit');
    this.setState({ errors, errTip: '' });
    const code = editorState.getCurrentContent().getPlainText();
    let parsed;
    try {
      parsed = Esprima.parse(`function x() { ${code} }`);
    } catch (e) {
      if (e.lineNumber > 0) {
        this.setState({ lineNumber: e.lineNumber, errDesc: e.description });
      }
      this.setState({
        errors: errors.add('FE_SYNTAXINVALID', 'submit'),
      });
      return;
    }
    if (code.indexOf('_config_') <= -1) {
      try {
        const evalCode = new Function(`${kCodeBlock}${code}`);
        evalCode();
      } catch (e) {
        const reg = new RegExp(/<anonymous>:(\d)*:/, 'g');
        const stack = reg.exec(e.stack);
        const errLine = Number(stack[0].split(':')[1]);
        this.setState({
          errors: errors.add('FE_SYNTAXINVALID', 'submit'),
          errTip: `${e.message}: ${errLine - 2}`,
        });
        return;
      }
    }
    const statements = parsed.body[0].body.body;
    if (statements.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit'),
      });
      return;
    }

    const returnStmts = _.flatMap(statements, findReturns);
    if (returnStmts.length === 0) {
      this.setState({
        errors: errors.add('FE_RETMISSING', 'submit'),
      });
      return;
    }

    const dataPoints = _.reduce(
      _.map(returnStmts, x => findDataPoints(x, statements)),
      (acc, dps) => _.union(acc, dps),
      [],
    );

    this.setState({
      submitStatus: 'pending',
      dataPoints,
    });
    // save the scripts
    callAPI({
      endpoint: `/lora/parsers/${parserId}`,
      method: 'PUT',
      body: {
        parser: { script: code },
      },
    }).then(() => {
      this.setState({
        errors: errors.remove('submit'),
        submitStatus: 'success',
      });
    }).catch((error) => {
      this.setState({
        errors: errors.add(error.code, 'submit'),
        submitStatus: 'failure',
      });
    });
  }

  render() {
    const {
      editorState,
      errors,
      submitStatus = '',
      lineNumber = 0,
      errDesc = '',
      errTip = '',
      copied = false,
    } = this.state;
    return (
      <div className={styles.editor}>
        <Editor
          blockRenderMap={blockRenderMap}
          blockStyleFn={() => styles.codeBlock}
          editorState={editorState}
          onChange={this.onChange}
          onTab={this.onTab}
          ref={(ref) => { this.editorRef = ref; }}
          blockRendererFn={blockRendererFn}
        />
        <div className={styles.submitBar}>
          <span className={`${styles.submitError} ${errors.has('submit') ? styles.show : ''}`}>
            <span className="halflings halflings-warning-sign" />{' '}
            {errTip === '' && this.intlMsg.errorMsg(errors.get('submit'))}
            {errTip !== '' && errTip }
            { lineNumber !== 0 &&
              `(${this.intlMsg.msg('line0')} ${lineNumber} ${this.intlMsg.msg('line1')} ${errDesc} )`
            }
          </span>
          <span>
            <Button
              bsStyle="aisz-primary"
              className={styles.copy}
              onClick={() => this.handleBeauty()}
            >
              {this.intlMsg.msg('beauty')}
            </Button>
            <Button
              bsStyle="aisz-primary"
              className={styles.copy}
              id="copy"
              data-clipboard-text={editorState.getCurrentContent().getPlainText()}
            >
              {this.intlMsg.msg('copy')}
            </Button>
            <Flash
              show={copied}
              message={this.intlMsg.msg('copid')}
              onHide={() => this.setState({ copied: false })}
              azStyle="success"
            />
          </span>
          <RichButton
            status={submitStatus}
            states={[{
              status: 'default',
              label: this.intlMsg.msg('submit'),
              style: 'primary',
              onClick: this.handleSubmit,
            }, {
              status: 'success',
              label: <span><span className="halflings halflings-tick" />{' '}{this.intlMsg.msg('submitsucc')}</span>,
              style: 'success',
              timer: () => this.setState({ submitStatus: '' }),
            }, {
              status: 'failure',
              label: <span><span className="halflings halflings-warning-sign" />{' '}{this.intlMsg.msg('submitfailure')}</span>,
              style: 'danger',
              timer: () => this.setState({ submitStatus: '' }),
            }, {
              status: 'pending',
              label: <span><i className="fa fa-spinner fa-spin" />{' '}{this.intlMsg.msg('submitting')}</span>,
              style: 'info',
            }]}
          />
        </div>
      </div>
    );
  }
}

ScriptEditor.propTypes = propTypes;

const mapStateToProps = state => ({
  parser: state.parser.getParser,
});

const mapDispatchToProps = {
  getParserCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ScriptEditor));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/ScriptEditor/index.jsx